/**
 * Copyright (c) 2010-2023 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { inject } from '@angular/core';
import { ZoomLatLonCommand } from './zoom-lat-lon.command';
import { MatDialog } from '@angular/material/dialog';
import { ZoomLatLonService } from './zoom-lat-lon.service';

export function zoomLatLonFactory() {
    const command = new ZoomLatLonCommand();
    command.setDependencies({
        dialog: inject(MatDialog),
        zoomLatLonService: inject(ZoomLatLonService)
    });
    return command;
}
